import { render, staticRenderFns } from "./overview-result-for-one-quality-score.vue?vue&type=template&id=dc3a5450"
import script from "./overview-result-for-one-quality-score.vue?vue&type=script&lang=js"
export * from "./overview-result-for-one-quality-score.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports